<app-header></app-header>

<div class="bsg-content-wrapper">
  <main id="content" role="main">
    <app-mkde-alert-list id="alert-wrapper"> </app-mkde-alert-list>

    <router-outlet></router-outlet>
  </main>
</div>
